export default "./images/survio-2LPG7-assets-reference-sk.png";